import {
	support3Color,
	whiteColor,
	blackColor,
	hexToRgb,
	blackColors,
	backgroundColor,
	grayColor,
	dark_grey_1,
	blue_1,
	dark_blue,
	primaryColor,
} from 'assets/jss/material-dashboard-pro-react';

const historyStyle = (theme) => ({
	amountCell: {
		textAlign: 'right',
	},
	generalPaymentDetails: {
		'& > div': {
			textAlign: 'left',
		},
		[theme.breakpoints.down('xs')]: {
			'& > div:not(:first-child)': {
				marginTop: 10,
			},
		},
		[theme.breakpoints.up('sm')]: {
			'& > div:not(:first-child)': {
				textAlign: 'right',
			},
		},
	},
	paymentDetailsContainer: {
		width: '100%',
		height: '100%',
		borderRadius: 8,
		boxShadow: `
		0 4px 4px 0 rgba(${hexToRgb(blackColor)}, 0.14), 0 7px 10px -5px ${support3Color[0]}
		`,
	},
	cell: {
		marginLeft: 8,
	},
	numbersAmount: {
		marginTop: 14,
		marginBottom: 0,
	},
	closeIcon: {
		color: blackColors[4],
		cursor: 'pointer',
		width: '14px',
	},
	paymentDetailsHeaderContainer: {
		padding: '13px 0 24px 13px',
		backgroundColor: whiteColor,
	},
	paymentDetailsHeader: {
		margin: '33px 0 0 11px',
	},
	paymentDetails: {
		height: 'calc(100% - 124px)',
		backgroundColor,
		borderTop: `2px solid ${grayColor[1]}`,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		padding: '16px 24px',
		overflow: 'auto',
	},
	customDateRange: {
		position: 'relative',
		'& > div': {
			width: '100%',
			position: 'relative',
		},
		'& .rdt input': {
			display: 'none',
		},
	},
	type: {
		margin: 0,
		cursor: 'pointer',
	},
	inlineIcon: { height: 16, width: 16, objectFit: 'cover', marginRight: 8 },
	document: {
		cursor: 'pointer',
	},
	tableAdditionalElement: {
		position: 'absolute',
		top: 0,
		right: 0,
		zIndex: 2,
		width: '67%',
		[theme.breakpoints.down('sm')]: {
			width: '90%',
		},
		height: '100%',
	},
	downloadButton: {
		background: primaryColor[0],
		color: whiteColor,
		height: '40px',
		borderRadius: '4px',
		padding: '0px 51px',
	},
	downloadInvoiceWrapper: {
		boxShadow: '0 0 24px 0',
		background: whiteColor,
		width: '100%',
		'& .MuiButton-root:hover, .MuiButton-root:focus': {
			background: `${blue_1} !important`,
			color: `${whiteColor} !important`,
		},
		'& .Mui-disabled': {
			backgroundColor: dark_grey_1,
			color: whiteColor,
		},
	},
	tableWrapper: {
		paddingBottom: '120px',
		width: '100%',
	},
	invoiceSelectSection: {
		background: grayColor[16],
		borderRight: `1px solid ${grayColor[0]}`,
		padding: '24px',
	},
	downloadText: {
		fontSize: `${theme.fontSize(12)} !important`,
		color: `${grayColor[7]} !important`,
	},
	selectedBillsCount: {
		padding: '24px',
	},
	downloadButtonWrapper: {
		marginLeft: '20px',
	},
	billPeriodWrapper: {
		background: whiteColor,
		position: 'absolute',
		width: '100%',
		zIndex: '999',
		padding: '15px',
		'& .rdt': {
			top: '85px !important',
		},
		boxShadow: `0px 14px 24px 0px ${dark_blue}`,
	},
	periodsWrapper: {
		background: whiteColor,
		boxShadow: `0px 14px 24px 0px ${dark_blue}`,
		width: '100%',
		position: 'absolute',
		zIndex: '1',
	},
	caption: {
		marginTop: '10px',
	},
	period: {
		borderBottom: `1px solid ${grayColor[0]}`,
		'& .MuiFormControlLabel-root': {
			padding: '10px !important',
		},
	},
	[theme.breakpoints.up('sm')]: {
		downloadInvoiceWrapper: ({ isNewHeaderVisible }) => ({
			boxShadow: '0 0 24px 0',
			display: 'flex',
			justifyContent: 'space-between',
			position: 'absolute',
			left: isNewHeaderVisible ? 'auto' : 0,
			height: '80px',
			zIndex: 2,
			alignItems: 'center',
			background: 'white',
			width: isNewHeaderVisible ? 'calc(100% - 24px)' : '100%',
			bottom: isNewHeaderVisible ? 0 : '100px',
		}),
		invoiceSelectSection: {
			padding: '30px 24px 24px 42px',
		},
		downloadButtonWrapper: {
			marginRight: '40px',
			'& button': {
				float: 'right',
			},
		},
	},

	[theme.breakpoints.up('md')]: {
		payBill: {
			gridTemplateColumns: '300px 250px auto',
			bottom: '106px',
		},
		periodsWrapper: {
			width: '30%',
		},
	},
});

export default historyStyle;
